import axiosAuth from '../../axiosMain';

async function show(company_id, data) {
  let response = await axiosAuth.post('/company_questionnaire_score_by_color/' + company_id, data);
  return response.data;
}

export default {
  show,
};
